import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipError } from '../../../validation/errors/betslip-error';
import { hasInsufficientMoneyError } from '../../../validation/services/utils/betslip-errors-utils';
import { StakeUpdateErrorModel } from '../../models';
import { PlaceButtonMode, PlaceButtonStates } from '../../state';

interface PlaceButtonActionInput {
    isAuthenticated: boolean;
    mode: PlaceButtonMode;
    hasLockedPick: boolean;
    hasLivePicks: boolean;
    oddsChanged: boolean;
    oddsAccepted: boolean;
    hasComboPreventionError: boolean;
    betslipErrors: BetslipError[];
    hasSuspendedPicks: boolean;
    stakeUpdateErrors: StakeUpdateErrorModel[];
}
@Injectable()
export class PlaceButtonActionStateService {
    constructor(private betslipConfig: BetslipConfig) {}

    getAction({
        isAuthenticated,
        mode,
        hasLockedPick,
        hasLivePicks,
        oddsChanged,
        oddsAccepted,
        hasComboPreventionError,
        betslipErrors,
        hasSuspendedPicks,
        stakeUpdateErrors,
    }: PlaceButtonActionInput): PlaceButtonStates {
        // Todo This works currently but a lot of the paths seem confusing and might not be needed
        // we should switch from PlaceButtonStates with enum flags to using Fixed states
        // So Login, UpdateStake, ProcessingDeposit instead of (Processing | Deposit) etc
        // then we should check the paths and remove unneeded ones

        if (!isAuthenticated) {
            return PlaceButtonStates.Login;
        }

        // eslint-disable-next-line no-bitwise
        if (mode & PlaceButtonMode.Deposit) {
            if (
                hasComboPreventionError ||
                hasLockedPick ||
                oddsChanged ||
                !this.betslipConfig.isDepositAndPlaceBetEnabled ||
                (!this.betslipConfig.isLiveOneClickDepositEnabled && hasLivePicks)
            ) {
                return PlaceButtonStates.Deposit;
            }

            // eslint-disable-next-line no-bitwise
            return PlaceButtonStates.Deposit | PlaceButtonStates.PlaceBet;
        }

        if (hasInsufficientMoneyError(betslipErrors)) {
            // eslint-disable-next-line no-bitwise
            return PlaceButtonStates.Processing | PlaceButtonStates.Deposit;
        }

        if (stakeUpdateErrors.length === 1) {
            return PlaceButtonStates.UpdateStake;
        }

        if (stakeUpdateErrors.length > 1) {
            return PlaceButtonStates.UpdateStakes;
        }

        if (hasLockedPick) {
            if (hasInsufficientMoneyError(betslipErrors)) {
                // eslint-disable-next-line no-bitwise
                return PlaceButtonStates.PlaceBet | PlaceButtonStates.Deposit;
            }

            return PlaceButtonStates.AcceptChanges;
        }

        //Suspended picks takes precedence to PlaceButtonStates.AcceptChanges since suspended picks will not have any auto action (accept changes CTA handler)
        if (hasSuspendedPicks) {
            return PlaceButtonStates.PlaceBet;
        }

        if (oddsChanged && !oddsAccepted) {
            if (hasInsufficientMoneyError(betslipErrors)) {
                return PlaceButtonStates.Deposit;
            }

            if (this.betslipConfig.isAcceptAndPlaceBetEnabled) {
                // eslint-disable-next-line no-bitwise
                return PlaceButtonStates.PlaceBet | PlaceButtonStates.AcceptChanges;
            }

            return PlaceButtonStates.AcceptChanges;
        }

        if (oddsChanged && oddsAccepted) {
            if (this.betslipConfig.isAcceptAndPlaceBetEnabled) {
                return PlaceButtonStates.PlaceBet;
            }

            return PlaceButtonStates.AcceptChanges;
        }

        // eslint-disable-next-line no-bitwise
        if (mode & PlaceButtonMode.Confirm) {
            return PlaceButtonStates.Confirm;
        }

        return PlaceButtonStates.PlaceBet;
    }
}
